import AppButton from '@nxsys/components/AppButton';
import { defaultTheme } from '@nxsys/constants/defaultConfig';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { UpdateCompanyByIdParams } from '@nxsys/types/api/company';
import { Icons } from '@nxsys/types/icons';
import { ICompany } from '@nxsys/types/models/company';
import { useCallback, useRef, useState } from 'react';
import ContactDetailForm, {
  ContactDetailFormRef,
  ContactDetailValues,
} from './components/ContactDetailForm';

type Props = {
  data?: ICompany;
  updateData: (params: UpdateCompanyByIdParams) => Promise<void>;
};

const ContactDetailTab: React.FC<Props> = ({ data, updateData }) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<ContactDetailFormRef>(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleSubmit = useCallback(
    async (values: ContactDetailValues) => {
      setIsUpdating(true);
      try {
        const params: UpdateCompanyByIdParams = {
          forename: values.forename,
          surname: values.surname,
          telephone: values.telephone || null,
          directDial: values.directDial,
          email: values.email || null,
          alternateEmail: values.alternateEmail || null,
        };
        await updateData(params);
      } finally {
        setIsUpdating(false);
      }
    },
    [updateData],
  );

  return (
    <div>
      {data && (
        <>
          <ContactDetailForm
            formRef={formRef}
            onSubmit={handleSubmit}
            defaultValues={{
              forename: data.forename ?? '',
              surname: data.surname ?? '',
              telephone: data.telephone ?? '',
              directDial: data.directDial ?? '',
              email: data.email ?? '',
              alternateEmail: data.alternateEmail ?? '',
            }}
          />
          <div className="flex items-center justify-start gap-3 pt-4">
            <AppButton
              type="primary"
              name={messages['common.save']}
              leftIcon={
                <Icons.IconCheckCircle
                  color={defaultTheme.theme.palette.white}
                />
              }
              onClick={() => formRef.current?.submit()}
              loading={isUpdating}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ContactDetailTab;
